import { DEFAULT_CHAIN_ID, SupportedChainId } from 'constants/chains'
import useHttpLocations from 'hooks/useHttpLocations'
import { useMemo } from 'react'
import { isAddress } from 'utils'

import ducxLogo from '../../assets/images/ducx-logo.png'
import { NATIVE_CHAIN_ID } from '../../constants/tokens'

export function chainIdToNetworkName(networkId: SupportedChainId) {
  switch (networkId) {
    case SupportedChainId.DUCX:
      return 'ducx_mainnet'
    case SupportedChainId.DUCX_TESTNET:
      return 'ducx_testnet'
    default:
      return 'ducx_mainnet'
  }
}

export function getNativeLogoURI(chainId: SupportedChainId = DEFAULT_CHAIN_ID): string {
  switch (chainId) {
    case SupportedChainId.DUCX:
      return ducxLogo
    case SupportedChainId.DUCX_TESTNET:
      return ducxLogo
    default:
      return ducxLogo
  }
}

function getTokenLogoURI(address: string, chainId: SupportedChainId = DEFAULT_CHAIN_ID): string | void {
  const networkName = chainIdToNetworkName(chainId)
  const networksWithUrls: SupportedChainId[] = []
  if (networksWithUrls.includes(chainId)) {
    return `https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/${networkName}/assets/${address}/logo.png`
  }
}

export default function useCurrencyLogoURIs(
  currency:
    | {
        isNative?: boolean
        isToken?: boolean
        address?: string
        chainId: number
        logoURI?: string | null
      }
    | null
    | undefined
): string[] {
  const locations = useHttpLocations(currency?.logoURI)
  return useMemo(() => {
    const logoURIs = [...locations]
    if (currency) {
      if (currency.isNative || currency.address === NATIVE_CHAIN_ID) {
        logoURIs.push(getNativeLogoURI(currency.chainId))
      } else if (currency.isToken || currency.address) {
        const checksummedAddress = isAddress(currency.address)
        const logoURI = checksummedAddress && getTokenLogoURI(checksummedAddress, currency.chainId)
        if (logoURI) {
          logoURIs.push(logoURI)
        }
      }
    }
    return logoURIs
  }, [currency, locations])
}
